import { CoordinatePickerContext } from './Map.tsx';
import { useContext } from 'react';
import { useMapEvents } from 'react-leaflet';

export const CoordinatePickerHandle = ({}: {}) => {
  const context = useContext(CoordinatePickerContext);
  if (!context) throw `no coordinate picker context initialized`;
  const { currentRequest, resetRequest } = context;
  useMapEvents({
    click(e) {
      if (currentRequest) {
        e.originalEvent.stopPropagation();
        e.originalEvent.preventDefault();
        currentRequest(e.latlng);
      }
      resetRequest();
    },
  });
  return <></>;
};
